import { commonGetToken } from 'utils/tool.js'
import { getOperateFlag } from 'api/platform/commonApi.js'

export default {
  data() {
    return {
      mixinShowCrisisBtn: false
    }
  },
  methods: {
    mixinFetchOperateFlag({ objectType, objectId }) {
      return commonGetToken(this)
        .then(token => {
          let params = {
            objectType, //对象类型，1=动态，2=文章，3=回答，4=直播，5=提问，6=FM节目，7=短视频，8=话题，9=群聊，10=用户，11=私信用户
            objectId,
            token
          }
          return getOperateFlag(params)
        })
        .then(res => {
          const { code, data } = res
          if (code == 0) {
            this.mixinShowCrisisBtn = data.isReport == 1
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
